import React, { useState } from 'react';
import { submitNewsletter } from '../services/firebaseService';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      const result = await submitNewsletter({ email });
      
      if (result.success) {
        setMessage('Thank you for subscribing! Welcome to our community.');
        setEmail('');
      } else {
        setMessage('Error subscribing. Please try again.');
        console.error('Newsletter subscription error:', result.error);
      }
    } catch (error) {
      setMessage('Error subscribing. Please try again.');
      console.error('Newsletter submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mb-8">
      <div className="text-center mb-6">
        <h4 className="text-xl font-bold text-cream-100 mb-2 font-display">Stay Updated</h4>
        <p className="text-cream-300 text-sm">Subscribe to our newsletter for exclusive offers and gift inspiration</p>
      </div>
      
      <form onSubmit={handleSubmit} className="max-w-md mx-auto">
        <div className="flex gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="flex-1 px-4 py-3 rounded-xl border border-cream-600/30 bg-cream-800/50 text-cream-100 placeholder-cream-400 focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300"
            placeholder="Enter your email"
          />
          
          <button
            type="submit"
            disabled={isSubmitting}
            className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
              isSubmitting 
                ? 'bg-gray-500 cursor-not-allowed text-gray-300' 
                : 'bg-gradient-to-r from-primary-500 to-accent-500 hover:from-primary-600 hover:to-accent-600 text-white transform hover:scale-105 shadow-lg'
            }`}
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </div>
      </form>

      {message && (
        <p className={`mt-3 text-sm text-center ${message.includes('Error') ? 'text-red-300' : 'text-green-300'}`}>
          {message}
        </p>
      )}
      
      <p className="text-cream-400 text-xs text-center mt-3">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </div>
  );
};

export default NewsletterSection;
